import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUpdateAction } from "../../network/store/action/SectionResponseAction";
import {
  formUpdateData,
  updateFormInfo,
} from "../../redux/slice/formUpdateSlice";
import { updateMessage } from "../../redux/slice/toastSlice";

const AddUpdateForm = (props) => {
  // TO get Callbacks
  const dispatch = useDispatch();
  const formData = useSelector(formUpdateData);
  const itemInfo = formData.item;
  // // Page Form
  const [dataForm, setDataForm] = useState({
    name: "",
  });

  useEffect(() => {
    console.log("Item Info =>", itemInfo);
    if (itemInfo != undefined) {
      let updateValues = {
        name: itemInfo.name,
      };
      setDataForm(updateValues);
    }
  }, []);

  const handleInputChanges = (e) => {
    setDataForm({
      ...dataForm,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmtClick = async () => {
    let requestBody = {
      name: dataForm.name,
    };

    if (itemInfo != undefined) {
      requestBody.id = itemInfo.id;
    }

    await dispatch(createUpdateAction(requestBody)).then((response) => {
      if (response.status == true) {
        if (props.onSubmit) props.onSubmit();
      } else {
        dispatch(
          updateMessage({
            display: true,
            message: "Error While updating info",
          })
        );
      }
    });
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          backgroundColor: "rgba(0,0,0,0.5)",
          width: "100%",
          height: "100%",
          zIndex: "999",
          overflow: "scroll",
        }}
      >
        <div className="d-flex align-item-center justify-content-center">
          <div className="col-md-8">
            <div className="container">
              <div className="row mt-5">
                <div className="col-md-5 card-1 p-5">
                  {itemInfo != undefined ? (
                    <h4 className="text-center">Update Category</h4>
                  ) : (
                    <h4 className="text-center"> Add Category</h4>
                  )}

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Category Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={dataForm.name}
                        onChange={(e) => handleInputChanges(e)}
                      />

                      <div
                        style={{
                          marginTop: 20,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{ display: "flex", justifyContent: "center" }}
                          type="button"
                          className="btn btn-purple-bg"
                          onClick={() => onSubmtClick()}
                        >
                          Submit
                        </button>
                        <button
                          className="btn btn-white-bg"
                          onClick={() => {
                            dispatch(
                              updateFormInfo({
                                displayForm: false,
                                formData: {},
                              })
                            );
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUpdateForm;
